import * as React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { Lecturer, ServerResponse, UploadImage } from '../../api';
import { CPLecturerComponent } from '../cpLecturerComponent/CPLecturerComponent';
import { EditState } from '../itemEditableComponent/ItemEditableComponent';
import './CPLecturerList.css';

export interface CPLecturerListProps {
    addNewRecord: () => void;
    cancelHandler: () => void;
    changeHandler: (editValue: string, field: string) => void;
    changeImage: (image: UploadImage) => void;
    imageData?: string;
    imageDelete: boolean;
    editItemID: number | undefined;
    editValue: Lecturer;
    errorClass: (fieldname: string) => string;
    errors: string[];
    serverResponse: ServerResponse | undefined;
    lecturers: Lecturer[];
    saveHandler: (entryId: number) => void;
    selectEntry: (entryId: number, selectionMethod: SelectionMethod) => void;
}

export interface CPLecturerListState {
    addNewValue: Lecturer;
}

export enum SelectionMethod {
    Delete,
    Edit,
}

export default class CPLecturerList extends React.PureComponent<CPLecturerListProps, CPLecturerListState> {
    constructor(props: any) {
        super(props);
        this.state = {
            addNewValue: {
                Description: '',
                FirstName: '',
                ID: 0,
                Image: { ID: '', ThumbnailURL: '', MediumURL: '', LargeURL: '' },
                LastName: '',
                ProfileURL: '',
                Salutation: '',
                Title: '',
            },
        };
    }

    public render() {
        const ed = this.props.editItemID === undefined;

        return (
            <Container>
                <Row>
                    <Col>
                        <h3>{TR.cPLecturerList_lecturers}</h3>
                    </Col>
                </Row>
                {this.props.lecturers.map(this.renderCPLecturerComponent)}
                <Row>
                    <Col>
                        <Button
                            id={'newLecturer'}
                            disabled={!ed}
                            onClick={() => {
                                this.props.addNewRecord();
                            }}
                        >
                            {TR.cPLecturerList_add_lecturer}
                        </Button>
                    </Col>
                </Row>
            </Container>
        );
    }

    private renderCPLecturerComponent = (lecturer: Lecturer) => {
        let editState: EditState;
        let error = false;

        if (
            this.props.editItemID === lecturer.ID &&
            this.props.serverResponse !== undefined &&
            !this.props.serverResponse.OK
        ) {
            error = true;
        }

        if (this.props.editItemID === lecturer.ID) {
            editState = EditState.This;
        } else if (this.props.editItemID === undefined) {
            editState = EditState.None;
        } else {
            editState = EditState.Other;
        }

        return (
            <React.Fragment key={lecturer.ID}>
                <CPLecturerComponent
                    cancelHandler={this.props.cancelHandler}
                    changeHandler={this.props.changeHandler}
                    changeImage={this.props.changeImage}
                    imageData={this.props.imageData}
                    imageDelete={this.props.imageDelete}
                    editState={editState}
                    entryId={lecturer.ID}
                    error={error}
                    errorClass={this.props.errorClass}
                    errors={this.props.errors}
                    lecturer={lecturer}
                    editValue={this.props.editValue}
                    saveHandler={this.props.saveHandler}
                    selectEntry={this.props.selectEntry}
                    serverResponse={this.props.serverResponse}
                />
            </React.Fragment>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpLecturerList/CPLecturerList.tsx